import React, { useCallback } from "react";
import { Paths } from "../../../Paths";
import { useSendLocationToGtag } from "../../hooks/common/useSendLocationToGtag";
import { useNavigate } from "react-router-dom";

export function AdminIndexPage() {

    const navigate =useNavigate();

    useSendLocationToGtag("管理者ページ");

    const handleServiceProviderListClicked = useCallback(() => {
        navigate(`${Paths.admin}${Paths.serviceProvider}${Paths.list}`);
    }, [history]);

    const handleUserListClicked = useCallback(() => {
        navigate(`${Paths.admin}${Paths.user}${Paths.list}`);
    }, [history]);

    const handleCareRecipientListClicked = useCallback(() => {
        navigate(`${Paths.admin}${Paths.careRecipient}${Paths.list}`);
    }, [history]);

    const handleAllListClicked = useCallback(() => {
        navigate(`${Paths.admin}${Paths.list}`);
    }, [history]);

    const handleLoginLogClicked = useCallback(() => {
        navigate(`${Paths.admin}${Paths.loginLog}`);
    }, [history]);

    const handleCareCommentAnalysis = useCallback(() => {
        navigate(`${Paths.admin}${Paths.careCommentAnalysis}`);
    }, [history]);

    const handleAdminOperationLogClicked = useCallback(() => {
        navigate(`${Paths.admin}${Paths.adminOperationLog}`);
    }, [history]);

    return (
        <div className={"admin_index_page"}>
            <div className={"page_title"}>
                管理者機能へようこそ
            </div>
            <div className={"body"}>
                <div className={"items"}>
                    <div className={"item"} onClick={handleAllListClicked}>
                        <span className={"item__label"}>利用者・ユーザー一覧</span>
                    </div>
                    <div className={"item"} onClick={handleCareRecipientListClicked}>
                        <span className={"item__label"}>利用者一覧</span>
                    </div>
                    <div className={"item"} onClick={handleUserListClicked}>
                        <span className={"item__label"}>ユーザー一覧</span>
                    </div>
                    <div className={"item"} onClick={handleServiceProviderListClicked}>
                        <span className={"item__label"}>事業者一覧</span>
                    </div>
                    <div className={"item"} onClick={handleLoginLogClicked}>
                        <span className={"item__label"}>ログイン履歴</span>
                    </div>
                    <div className={"item"} onClick={handleCareCommentAnalysis}>
                        <span className={"item__label"}>ケアコメント分析</span>
                    </div>
                    <div className={"item"} onClick={handleAdminOperationLogClicked}>
                        <span className={"item__label"}>操作ログ</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
